<template>
  <transition name="fade">
    <div v-if="isVisible && roleData" class="rdp-overlay" @click.self="close">
      <transition name="pop" appear>
        <div class="rdp-modal">
          
          <!-- Header -->
          <div class="rdp-header">
            <div class="rdp-header-left">
              <div class="rdp-meta-label">ROLE DETAILS</div>
              <div class="rdp-status-tag" :class="isHiringOpen ? 'status-open' : 'status-closed'">
                {{ isHiringOpen ? 'Open Role' : 'Closed' }}
              </div>
            </div>
            <button class="rdp-close-btn" @click="close">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>

          <!-- Body with Invisible Scrollbar -->
          <div class="rdp-body">
            <div class="rdp-title-container">
              <h1 class="rdp-role-title">{{ roleData.title }}</h1>
              <!-- This span will only show if 'roleLevel' has a value -->
              <span v-if="roleLevel" class="rdp-level-chip">{{ roleLevel }}</span>
            </div>

            <!-- Role Description Block -->
            <div class="rdp-text-block">
              <h3 class="rdp-bold-heading">Role Description</h3>
              <p class="rdp-paragraph" v-html="parsedDescription"></p>
            </div>

            <!-- Skills Block -->
            <div class="rdp-text-block">
              <h3 class="rdp-bold-heading">Skills</h3>
              
              <!-- Functional Skills Row -->
              <div class="rdp-skill-row">
                <span class="rdp-bold-label">Functional Skills:</span>
                <span class="rdp-skill-text">{{ functionalSkillsList || 'None listed' }}</span>
              </div>
              
              <!-- Soft Skills Row -->
              <div class="rdp-skill-row">
                <span class="rdp-bold-label">Soft Skills:</span>
                <span class="rdp-skill-text">{{ softSkillsList || 'None listed' }}</span>
              </div>
            </div>

          </div>

          <!-- Footer -->
          <div class="rdp-footer">
            <button class="rdp-btn rdp-btn-outline" @click="copyDetails">
              Copy Details
            </button>
            <button class="rdp-btn rdp-btn-primary" @click="close">Okay</button>
          </div>

        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RoleDetailsPopup',
  data() {
    return {
      isVisible: false,
      roleData: null,
      roleLevel: null,
    };
  },
  // *** THE FIX IS HERE: MOVED THE SKILLS LOGIC INTO THE COMPUTED SECTION ***
  computed: {
    isHiringOpen() {
      return this.roleData?.softSkills?.includes('[OPEN_HIRING]');
    },
    parsedDescription() {
      const descArray = this.roleData?.description;
      if (Array.isArray(descArray) && descArray.length > 0) {
        // Get the last item in the array, which is the most recent description
        const latestEntry = descArray[descArray.length - 1];
        if (latestEntry && latestEntry.msg) {
          // Clean up the "[ROLE_DESC_SAVE]" tag
          return latestEntry.msg.replace('[ROLE_DESC_SAVE]', '').trim();
        }
      }
      // Fallback to roleSummary if description array is missing
      return this.roleData?.roleSummary || "No description available.";
    },
    functionalSkillsList() {
      const s = this.roleData?.skills || [];
      return s.length > 0 ? s.join(', ') : null;
    },
    softSkillsList() {
      const s = (this.roleData?.softSkills || []).filter(item => item !== '[OPEN_HIRING]');
      return s.length > 0 ? s.join(', ') : null;
    }
  },
  methods: {
    async open(role) {
      this.roleData = role;
      this.isVisible = true;
      this.roleLevel = null; // Reset on open

      // Fetch the level from the Python backend
      try {
        const API_BASE_URL = process.env.VUE_APP_API_URL;
        const response = await fetch(`${API_BASE_URL}/api/role/${role.selfId}/level`);
        if (response.ok) {
          const data = await response.json();
          this.roleLevel = data.level;
        }
      } catch (error) {
        console.warn("Could not fetch role level:", error);
      }
    },
    close() {
      this.isVisible = false;
      setTimeout(() => { this.roleData = null; }, 300);
    },
    copyDetails() {
      const text = `Role: ${this.roleData.title}\n\nRole Description:\n${this.parsedDescription}\n\nSkills:\nFunctional Skills: ${this.functionalSkillsList}\nSoft Skills: ${this.softSkillsList}`;
      navigator.clipboard.writeText(text);
      if (this.$vs) this.$vs.notify({ title: 'Copied', text: 'Details copied to clipboard', color: 'success' });
    }
  }
};
</script>

<style scoped>
.rdp-overlay {
  position: fixed; inset: 0; background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(4px); z-index: 1000000; display: flex; align-items: center; justify-content: center;
}
.rdp-modal {
  width: 90%; max-width: 600px; background: #ffffff; border-radius: 16px;
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15); overflow: hidden;
  font-family: 'Inter', -apple-system, sans-serif;
}
.rdp-header {
  padding: 20px 32px; border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
}
.rdp-header-left { display: flex; align-items: center; gap: 12px; }
.rdp-meta-label { font-size: 11px; font-weight: 800; color: #94a3b8; letter-spacing: 1px; }
.rdp-status-tag { font-size: 11px; font-weight: 700; padding: 4px 12px; border-radius: 20px; }
.status-open { background: #fef3c7; color: #92400e; }
.status-closed { background: #f1f5f9; color: #64748b; }
.rdp-close-btn { background: none; border: none; cursor: pointer; color: #cbd5e1; transition: color 0.2s; }
.rdp-close-btn:hover { color: #64748b; }
.rdp-body { 
  padding: 32px; 
  max-height: 65vh; 
  overflow-y: auto; 
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.rdp-body::-webkit-scrollbar {
  display: none;
}
.rdp-role-title { font-size: 26px; font-weight: 800; color: #0f172a; margin: 0 0 24px 0; }
.rdp-text-block { margin-bottom: 24px; }
.rdp-text-block:last-child { margin-bottom: 0; }
.rdp-bold-heading {
  font-size: 15px; 
  font-weight: 700;
  color: #0f172a; 
  margin: 0 0 8px 0;
}
.rdp-paragraph {
  font-size: 14px; 
  line-height: 1.6; 
  color: #475569; 
  margin: 0;
}
.rdp-skill-row { 
  margin-bottom: 8px; 
  font-size: 14px;
  line-height: 1.5;
}
.rdp-skill-row:last-child { margin-bottom: 0; }
.rdp-bold-label { 
  font-weight: 700;
  color: #0f172a; 
  margin-right: 6px; 
}
.rdp-skill-text { 
  color: #475569; 
}
.rdp-footer { 
  padding: 16px 32px; background: #f8fafc; border-top: 1px solid #f1f5f9; 
  display: flex; justify-content: flex-end; gap: 12px;
}
.rdp-btn { 
  display: flex; align-items: center; padding: 10px 20px; border-radius: 8px; 
  font-size: 13px; font-weight: 600; cursor: pointer; border: none; transition: transform 0.1s;
}
.rdp-btn:active { transform: scale(0.98); }
.rdp-btn-outline { background: #ffffff; border: 1px solid #e2e8f0; color: #475569; }
.rdp-btn-primary { background: #F59E0B; color: #ffffff; }
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }
.pop-enter-active { transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
.pop-enter { opacity: 0; transform: scale(0.95); }

.rdp-title-container {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.rdp-role-title {
  margin: 0; /* Remove margin from the title itself */
}

.rdp-level-chip {
  background-color: #f1f5f9;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 14px;
  border-radius: 999px;
  white-space: nowrap;
}
</style>